export const TODO_SET_SHOW_MODAL = "TODO_SET_SHOW_MODAL";
export const TODO_SET_NEW = "TODO_SET_NEW";
export const TODO_GET_ALL = "TODO_GET_ALL";
export const TODO_SET_PROPERTY = "TODO_SET_PROPERTY";
export const TODO_LIST_SET_PROPERTY = "TODO_LIST_SET_PROPERTY";
export const TODO_TASK_TO_EDIT = "TODO_TASK_TO_EDIT";
export const TODO_DELETE_TASK = "TODO_DELETE_TASK";
export const TODOS_GET_AND_LOAD_TO_STORAGE = "TODOS_GET_AND_LOAD_TO_STORAGE";
export const TODO_DELETE_ALL = "TODO_DELETE_ALL";
export const TODOS_SORT_LIST = "TODOS_SORT_LIST";
